export const PAYS_OCEANIE = [
    { code: 'AU', nom: 'Australie', capitale: 'Canberra', drapeau: '🇦🇺' },
    { code: 'FJ', nom: 'Fidji', capitale: 'Suva', drapeau: '🇫🇯' },
    { code: 'KI', nom: 'Kiribati', capitale: 'Tarawa Sud', drapeau: '🇰🇮' },
    { code: 'MH', nom: 'Îles Marshall', capitale: 'Majuro', drapeau: '🇲🇭' },
    { code: 'FM', nom: 'Micronésie', capitale: 'Palikir', drapeau: '🇫🇲' },
    { code: 'NR', nom: 'Nauru', capitale: 'Yaren', drapeau: '🇳🇷' },
    { code: 'NZ', nom: 'Nouvelle-Zélande', capitale: 'Wellington', drapeau: '🇳🇿' },
    { code: 'PW', nom: 'Palaos', capitale: 'Ngerulmud', drapeau: '🇵🇼' },
    { code: 'PG', nom: 'Papouasie-Nouvelle-Guinée', capitale: 'Port Moresby', drapeau: '🇵🇬' },
    { code: 'SB', nom: 'Îles Salomon', capitale: 'Honiara', drapeau: '🇸🇧' },
    { code: 'WS', nom: 'Samoa', capitale: 'Apia', drapeau: '🇼🇸' },
    { code: 'TO', nom: 'Tonga', capitale: 'Nuku\'alofa', drapeau: '🇹🇴' },
    { code: 'TV', nom: 'Tuvalu', capitale: 'Funafuti', drapeau: '🇹🇻' },
    { code: 'VU', nom: 'Vanuatu', capitale: 'Port-Vila', drapeau: '🇻🇺' }
];